(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AgendaDayPart', ['$rootScope', AgendaDayPartFn]);

    // class for agenda day part
    function AgendaDayPartFn($rootScope) {

        var AgendaDayPart = function (caption, begin, end, useDayParts) {

            var data = {
                collapsed: false, // open/collapse div -> default for ringfoon
                caption : caption, // caption 
                times : [], // time objects
                appointmentsCount : 0, // number of appointments in day-part
                begin : begin, // begin hour
                end: end, // end hour
                useDayParts: useDayParts // using of day-parts-split
            };
                     
            // collapse
            function collapse(toCollapse) {
                if (toCollapse) {
                    data.collapsed = toCollapse;
                } // if
                else {
                    data.collapsed = toCollapse;
                    init();
                } // else
            } // collapse

            function init() {
                // should content-view be collapsed ? -> depending on current time
                if ($rootScope.isRingfoon === false && useDayParts) {
                    var current = new Date();
                    // collapse if time is not actual 
                    if (current.getHours() < begin || current.getHours() >= end) {
                        data.collapsed = true;
                        current = null;
                    } // if
                } // if
            } // init

            // clear
            function clear() {
                data.times = [];
                data.appointmentsCount = 0;
            } // clear


            this.collapse = collapse;
            this.clear = clear;
            this.data = data;

            init();

        };
        
        return AgendaDayPart;


    }
})();